export enum TimelineEdgeArrowDirection {
  Left = 'left',
  Right = 'right',
}

type BarPosition = {
  left: number;
  width: number;
};

// Which edge arrow to show for a bar at the current horizontal scroll: Left when
// the bar sits entirely past the left edge of the viewport, Right when entirely
// past the right edge, null while any part of it is visible.
export const getTimelineEdgeArrow = (
  { left, width }: BarPosition,
  scrollLeft: number,
  viewportWidth: number,
): TimelineEdgeArrowDirection | null => {
  if (viewportWidth <= 0) {
    return null;
  }
  if (left + width <= scrollLeft) {
    return TimelineEdgeArrowDirection.Left;
  }
  if (left >= scrollLeft + viewportWidth) {
    return TimelineEdgeArrowDirection.Right;
  }
  return null;
};
